import {Key} from 'react';

import {ReviewTopicType} from '../../../../../service/reivew-analysis/review-topics/review-topics-type';

export type TopicTableDataType = ReviewTopicType & {
    key: Key;
    action: JSX.Element;
};

export enum KeywordsAndTopicsTabsEnum {
    Topics = 'topics',
    Keywords = 'keywords',
    Aspects = 'aspects',
    UserTags = 'userTags',
}
